import * as Sentry from "@sentry/react";

export function initClientMonitoring(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: 'beta',
    sendDefaultPii: false,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      if (event.tags?.flow !== "create_enrollment") {
        return null;
      }
      return event;
    },
  });
}

export function isSentryEnabled(): boolean {
  return Boolean(process.env.REACT_APP_SENTRY_DSN);
}

export { Sentry };
